import React from 'react';

import Filter from './filter';
import FilterButton from 'components/search_sidebar/filter_button';
import { filterSchemas, hasFilters } from './helpers';

import type { CustomFieldFiltersProps } from './types';

export default function CustomFieldFilters({
  changeFilter,
  filterFunction,
  filters,
  schemas
}: CustomFieldFiltersProps) {
  return (
    <FilterButton
      filtersApplied={hasFilters(schemas, filters, filterFunction)}
      label="Custom Fields"
      name="custom-fields"
    >
      <div className="d-flex flex-column gap-2">
        {filterSchemas(schemas, filterFunction).map(schema => (
          <Filter
            changeFilter={changeFilter}
            filter={filters[schema.slug]}
            key={schema.id}
            schema={schema}
          />
        ))}
      </div>
    </FilterButton>
  );
}
